import React, { useEffect, useState } from "react";
import Layout from "../components/layout";
import "../styles/app.scss";
import imgSrc from "../assets/images/fraud-prevention.jpg";
export default function Home() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Function to check if the viewport width is less than a certain value
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768); // Example breakpoint: 768px
    };

    // Initial check
    checkIsMobile();

    // Listen to window resize event
    window.addEventListener("resize", checkIsMobile);

    // Cleanup function to remove the resize event listener
    return () => {
      window.removeEventListener("resize", checkIsMobile);
    };
  }, []);
  return (
    <>
      <Layout
        title="Fraud Webinars"
        metaDescription="HSBC Intermediaries Webinars for Fraud Prevention"
        disableWrapper={true}
      >
        <div></div>
        <div
          style={{
            backgroundImage: `url(${imgSrc})`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "auto",
            height: "33vw",
            width: "100%",
            maxHeight: "300px",
          }}
        ></div>
        <div
          style={{
            padding: "25px 0",
          }}
        >
          <div className="wrapper" style={{ display: "block" }}>
            <h1 className="page-title">HSBC UK Fraud webinars </h1>
            <p>
              All sessions are CPD approved. To register for one of the webinars, please click on your preferred option below and enter your details.
            </p>
            <p>
              <strong>2026 Mortgage Fraud Prevention</strong>
            </p>
            <p>
              Stay ahead of the curve with HSBC UK’s CPD approved Mortgage Fraud Prevention webinars – with a brand-new theme for 2026. These sessions will give you practical insights into the latest fraud trends, help you recognise suspicious mortgage applications, interpret CIFAS alerts, and spot key red flags.
            </p>
          </div>
          <div
            className="wrapper"
            style={{
              gap: "20px",
              width: "100%",
              display: "flex",
              alignItems: "stretch",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <div
              className="accordion__body"
              style={{
                backgroundColor: "white",
                width: isMobile ? "100%" : "calc(85% - 10px)",
                maxWidth: "100%",
              }}
            >
              <table style={{margin: "0 auto 20px"}}>
                <tbody>
                  <tr>
                    <td>
                      <p>
                        <a href="https://hsbc.zoom.us/webinar/register/WN_z07y1K0uTMC3B595QP5QoA">
                          Tuesday 12<sup>th</sup> May – 9:30am
                        </a>
                      </p>
                    </td>
                    <td>
                      <p>
                        <a href="https://hsbc.zoom.us/webinar/register/WN_IDm5xhlvTtKZWmjQVEJmiA">
                          Friday 19<sup>th</sup> June – 12:00pm
                        </a>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}
